<template>
	<div v-html="$t('serviceTerms.message')">
	</div>
</template>
<style>
</style>
<script>
    export default {

    }
</script>


// WEBPACK FOOTER //
// Terms.vue?0999e2f3